import { makeStyles } from '@paintscout/ui'
import type { MuiTheme as Theme } from '@paintscout/ui'
import { scheduleJobFieldStyles } from './fieldStyles'
import { scheduleJobLayoutStyles } from './layoutStyles'
import { scheduleJobOptionStyles } from './optionStyles'
import { scheduleJobPanelStyles } from './panelStyles'

export const useScheduleJobDialogStyles = makeStyles<Theme>(() => ({
  ...scheduleJobLayoutStyles,
  ...scheduleJobFieldStyles,
  ...scheduleJobPanelStyles,
  ...scheduleJobOptionStyles
}))

export type ScheduleJobDialogClasses = ReturnType<typeof useScheduleJobDialogStyles>
